import css from './Panel.css'

import { on, ready, query, queryAll } from '../../lib/dom.js'
import { ScrewScene, MixOperation } from '../../lib/scene.js'
import { fireEvent } from '../../lib/jsfunc.js'

function evalAndReturn(string) {
  string = string.replace('THREE.MixOperation', MixOperation)
  return eval('(function(){return '+string+';})()')
}

ready(function () {
  if ( !query('.Panel')) return

  var div = query('.panel-content-3dansicht div[data-name="3d"]')
  if (div) {
    var meshurl = div.getAttribute('data-meshurl')
    var material = div.getAttribute('data-material')

    material = evalAndReturn(material)
    // Initial 3D Scene rendern
    div.scene = new ScrewScene('.image[data-name="3d"]', meshurl, material);
    div.scene.start();
  }
  if(query('.panel-produkte .Select input[type=hidden]'))
    fireEvent(query('.panel-produkte .Select input[type=hidden]'), 'change');
})

on('change', '.panel-produkte .Select input[type=hidden]', function (event) {
  event.preventDefault()

  var kategorie, meshurl, material, key, li;
  key = event.target.value;
  li = query('.SelectOptions li[data-key="'+key+'"]');

  kategorie = event.target.closest('div.pointer').getAttribute('data-name');
  meshurl  = query(li, '.SelectProdukteLi').getAttribute('data-meshurl');
  material = query(li, '.SelectProdukteLi').getAttribute('data-material');

  var obj = query('.panel-content-3dansicht div.image'+kategorie+'[data-name="3d"]');
  if (obj) {
    obj.scene.loadMesh(meshurl);
    obj.scene.setPhong(evalAndReturn(material));

    obj.setAttribute('data-meshurl', meshurl);
    obj.setAttribute('data-material', material);
  }
})

on('click', '.Panel.pointer', function (event) {
  var panel = event.target.closest('.Panel');
  var url = panel.getAttribute('data-url');
  if(url){
    window.location = url;
  }
})
